"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SysSizeBorderwidth = exports.SysColorTextSemantic = exports.SysColorTextDisabled = exports.SysColorTextContent = exports.SysColorIconfill = exports.SysColorBorder = exports.RefColor = exports.CompToastColorText = exports.CompToastColorSeparator = exports.CompToastColorSemanticicon = exports.CompToastColorCloseicon = exports.CompToastColorBorder = exports.CompToastColorBackground = exports.CompTextlinkColorText = exports.CompTextlinkColorBackground = exports.CompTableColorBackgroundTotalcell = exports.CompTableColorBackgroundDefaultcell = exports.CompTableCellFont = exports.CompShortcutBackground = exports.CompSegmentedcontrolColorBackground = exports.CompPlaceholderShimmer = exports.CompPlaceholderBackground = exports.CompCalendarColorIconIconfill = exports.CompCalendarColorBackgroundCellNotfilled = exports.CompCalendarColorBackgroundCellFilled = exports.CompCalendarColorBackgroundCalendarevent = exports.CompButtonFont = exports.CompButtonColorTextMidemphasismonochrome = exports.CompButtonColorTextMidemphasis = exports.CompButtonColorTextLowemphasis = exports.CompButtonColorTextHighemphasis = exports.CompButtonColorIconMidemphasismonochrome = exports.CompButtonColorIconMidemphasis = exports.CompButtonColorIconLowemphasis = exports.CompButtonColorIconHighemphasis = exports.CompButtonColorBorderMidemphasismonochrome = exports.CompButtonColorBorderMidemphasis = exports.CompButtonColorBackgroundMidemphasismonochrome = exports.CompButtonColorBackgroundMidemphasis = exports.CompButtonColorBackgroundLowemphasis = exports.CompButtonColorBackgroundHighemphasis = exports.CompBulkselectorColorText = exports.CompBulkselectorColorIconfill = exports.CompBulkselectorColorBorder = exports.CompBulkselectorColorBackground = exports.CompAvatarSmall = exports.CompAlertsColorText = exports.CompAlertsColorSeparator = exports.CompAlertsColorSemanticicon = exports.CompAlertsColorCloseicon = exports.CompAlertsColorBorder = exports.CompAlertsColorBar = exports.CompAlertsColorBackground = void 0;
var SysColorTextContent = exports.SysColorTextContent = /*#__PURE__*/function (SysColorTextContent) {
  SysColorTextContent["main"] = "main";
  SysColorTextContent["auxiliary"] = "auxiliary";
  SysColorTextContent["ondark"] = "ondark";
  SysColorTextContent["primary"] = "primary";
  SysColorTextContent["accent"] = "accent";
  return SysColorTextContent;
}({});
var SysColorTextDisabled = exports.SysColorTextDisabled = /*#__PURE__*/function (SysColorTextDisabled) {
  SysColorTextDisabled["onlight"] = "onlight";
  SysColorTextDisabled["ondisabled"] = "ondisabled";
  return SysColorTextDisabled;
}({});
var SysColorTextSemantic = exports.SysColorTextSemantic = /*#__PURE__*/function (SysColorTextSemantic) {
  SysColorTextSemantic["error"] = "error";
  SysColorTextSemantic["success"] = "success";
  return SysColorTextSemantic;
}({});
var SysColorBorder = exports.SysColorBorder = /*#__PURE__*/function (SysColorBorder) {
  SysColorBorder["enabled"] = "enabled";
  SysColorBorder["active"] = "active";
  SysColorBorder["error"] = "error";
  SysColorBorder["warning"] = "warning";
  SysColorBorder["success"] = "success";
  SysColorBorder["decorative"] = "decorative";
  SysColorBorder["disabled"] = "disabled";
  SysColorBorder["ondark"] = "ondark";
  SysColorBorder["focusring"] = "focusring";
  SysColorBorder["disabledondisabled"] = "disabledondisabled";
  return SysColorBorder;
}({});
var SysColorIconfill = exports.SysColorIconfill = /*#__PURE__*/function (SysColorIconfill) {
  SysColorIconfill["ondark"] = "ondark";
  SysColorIconfill["onlight"] = "onlight";
  SysColorIconfill["error"] = "error";
  SysColorIconfill["warning"] = "warning";
  SysColorIconfill["success"] = "success";
  SysColorIconfill["disabled"] = "disabled";
  SysColorIconfill["ondisabled"] = "ondisabled";
  SysColorIconfill["primary"] = "primary";
  return SysColorIconfill;
}({});
var SysSizeBorderwidth = exports.SysSizeBorderwidth = /*#__PURE__*/function (SysSizeBorderwidth) {
  SysSizeBorderwidth["thin"] = "thin";
  SysSizeBorderwidth["thick"] = "thick";
  return SysSizeBorderwidth;
}({});
var CompButtonFont = exports.CompButtonFont = /*#__PURE__*/function (CompButtonFont) {
  CompButtonFont["standard"] = "standard";
  return CompButtonFont;
}({});
var CompButtonColorBackgroundHighemphasis = exports.CompButtonColorBackgroundHighemphasis = /*#__PURE__*/function (CompButtonColorBackgroundHighemphasis) {
  CompButtonColorBackgroundHighemphasis["hover"] = "hover";
  CompButtonColorBackgroundHighemphasis["pressed"] = "pressed";
  CompButtonColorBackgroundHighemphasis["default"] = "default";
  CompButtonColorBackgroundHighemphasis["disabled"] = "disabled";
  return CompButtonColorBackgroundHighemphasis;
}({});
var CompButtonColorBackgroundMidemphasis = exports.CompButtonColorBackgroundMidemphasis = /*#__PURE__*/function (CompButtonColorBackgroundMidemphasis) {
  CompButtonColorBackgroundMidemphasis["hover"] = "hover";
  CompButtonColorBackgroundMidemphasis["pressed"] = "pressed";
  return CompButtonColorBackgroundMidemphasis;
}({});
var CompButtonColorBackgroundLowemphasis = exports.CompButtonColorBackgroundLowemphasis = /*#__PURE__*/function (CompButtonColorBackgroundLowemphasis) {
  CompButtonColorBackgroundLowemphasis["hover"] = "hover";
  CompButtonColorBackgroundLowemphasis["pressed"] = "pressed";
  return CompButtonColorBackgroundLowemphasis;
}({});
var CompButtonColorBackgroundMidemphasismonochrome = exports.CompButtonColorBackgroundMidemphasismonochrome = /*#__PURE__*/function (CompButtonColorBackgroundMidemphasismonochrome) {
  CompButtonColorBackgroundMidemphasismonochrome["hover"] = "hover";
  CompButtonColorBackgroundMidemphasismonochrome["pressed"] = "pressed";
  return CompButtonColorBackgroundMidemphasismonochrome;
}({});
var CompButtonColorBorderMidemphasis = exports.CompButtonColorBorderMidemphasis = /*#__PURE__*/function (CompButtonColorBorderMidemphasis) {
  CompButtonColorBorderMidemphasis["default"] = "default";
  CompButtonColorBorderMidemphasis["disabled"] = "disabled";
  CompButtonColorBorderMidemphasis["hover"] = "hover";
  CompButtonColorBorderMidemphasis["pressed"] = "pressed";
  return CompButtonColorBorderMidemphasis;
}({});
var CompButtonColorBorderMidemphasismonochrome = exports.CompButtonColorBorderMidemphasismonochrome = /*#__PURE__*/function (CompButtonColorBorderMidemphasismonochrome) {
  CompButtonColorBorderMidemphasismonochrome["default"] = "default";
  CompButtonColorBorderMidemphasismonochrome["hover"] = "hover";
  CompButtonColorBorderMidemphasismonochrome["pressed"] = "pressed";
  CompButtonColorBorderMidemphasismonochrome["disabled"] = "disabled";
  return CompButtonColorBorderMidemphasismonochrome;
}({});
var CompButtonColorTextHighemphasis = exports.CompButtonColorTextHighemphasis = /*#__PURE__*/function (CompButtonColorTextHighemphasis) {
  CompButtonColorTextHighemphasis["default"] = "default";
  CompButtonColorTextHighemphasis["hover"] = "hover";
  CompButtonColorTextHighemphasis["pressed"] = "pressed";
  CompButtonColorTextHighemphasis["disabled"] = "disabled";
  return CompButtonColorTextHighemphasis;
}({});
var CompButtonColorTextMidemphasis = exports.CompButtonColorTextMidemphasis = /*#__PURE__*/function (CompButtonColorTextMidemphasis) {
  CompButtonColorTextMidemphasis["default"] = "default";
  CompButtonColorTextMidemphasis["hover"] = "hover";
  CompButtonColorTextMidemphasis["pressed"] = "pressed";
  CompButtonColorTextMidemphasis["disabled"] = "disabled";
  return CompButtonColorTextMidemphasis;
}({});
var CompButtonColorTextLowemphasis = exports.CompButtonColorTextLowemphasis = /*#__PURE__*/function (CompButtonColorTextLowemphasis) {
  CompButtonColorTextLowemphasis["default"] = "default";
  CompButtonColorTextLowemphasis["pressed"] = "pressed";
  CompButtonColorTextLowemphasis["hover"] = "hover";
  CompButtonColorTextLowemphasis["disabled"] = "disabled";
  return CompButtonColorTextLowemphasis;
}({});
var CompButtonColorTextMidemphasismonochrome = exports.CompButtonColorTextMidemphasismonochrome = /*#__PURE__*/function (CompButtonColorTextMidemphasismonochrome) {
  CompButtonColorTextMidemphasismonochrome["default"] = "default";
  CompButtonColorTextMidemphasismonochrome["hover"] = "hover";
  CompButtonColorTextMidemphasismonochrome["pressed"] = "pressed";
  CompButtonColorTextMidemphasismonochrome["disabled"] = "disabled";
  return CompButtonColorTextMidemphasismonochrome;
}({});
var CompButtonColorIconHighemphasis = exports.CompButtonColorIconHighemphasis = /*#__PURE__*/function (CompButtonColorIconHighemphasis) {
  CompButtonColorIconHighemphasis["default"] = "default";
  CompButtonColorIconHighemphasis["hover"] = "hover";
  CompButtonColorIconHighemphasis["pressed"] = "pressed";
  CompButtonColorIconHighemphasis["disabled"] = "disabled";
  return CompButtonColorIconHighemphasis;
}({});
var CompButtonColorIconMidemphasis = exports.CompButtonColorIconMidemphasis = /*#__PURE__*/function (CompButtonColorIconMidemphasis) {
  CompButtonColorIconMidemphasis["default"] = "default";
  CompButtonColorIconMidemphasis["hover"] = "hover";
  CompButtonColorIconMidemphasis["pressed"] = "pressed";
  CompButtonColorIconMidemphasis["disabled"] = "disabled";
  return CompButtonColorIconMidemphasis;
}({});
var CompButtonColorIconMidemphasismonochrome = exports.CompButtonColorIconMidemphasismonochrome = /*#__PURE__*/function (CompButtonColorIconMidemphasismonochrome) {
  CompButtonColorIconMidemphasismonochrome["default"] = "default";
  CompButtonColorIconMidemphasismonochrome["hover"] = "hover";
  CompButtonColorIconMidemphasismonochrome["pressed"] = "pressed";
  CompButtonColorIconMidemphasismonochrome["disabled"] = "disabled";
  return CompButtonColorIconMidemphasismonochrome;
}({});
var CompButtonColorIconLowemphasis = exports.CompButtonColorIconLowemphasis = /*#__PURE__*/function (CompButtonColorIconLowemphasis) {
  CompButtonColorIconLowemphasis["default"] = "default";
  CompButtonColorIconLowemphasis["hover"] = "hover";
  CompButtonColorIconLowemphasis["pressed"] = "pressed";
  CompButtonColorIconLowemphasis["disabled"] = "disabled";
  return CompButtonColorIconLowemphasis;
}({});
var CompTableCellFont = exports.CompTableCellFont = /*#__PURE__*/function (CompTableCellFont) {
  CompTableCellFont["regular"] = "regular";
  CompTableCellFont["link"] = "link";
  CompTableCellFont["bold"] = "bold";
  return CompTableCellFont;
}({});
var CompTableColorBackgroundDefaultcell = exports.CompTableColorBackgroundDefaultcell = /*#__PURE__*/function (CompTableColorBackgroundDefaultcell) {
  CompTableColorBackgroundDefaultcell["selected"] = "selected";
  CompTableColorBackgroundDefaultcell["hover"] = "hover";
  return CompTableColorBackgroundDefaultcell;
}({});
var CompTableColorBackgroundTotalcell = exports.CompTableColorBackgroundTotalcell = /*#__PURE__*/function (CompTableColorBackgroundTotalcell) {
  CompTableColorBackgroundTotalcell["selected"] = "selected";
  CompTableColorBackgroundTotalcell["hover"] = "hover";
  CompTableColorBackgroundTotalcell["default"] = "default";
  return CompTableColorBackgroundTotalcell;
}({});
var CompAvatarSmall = exports.CompAvatarSmall = /*#__PURE__*/function (CompAvatarSmall) {
  CompAvatarSmall["text"] = "text";
  return CompAvatarSmall;
}({});
var CompBulkselectorColorBackground = exports.CompBulkselectorColorBackground = /*#__PURE__*/function (CompBulkselectorColorBackground) {
  CompBulkselectorColorBackground["default"] = "default";
  CompBulkselectorColorBackground["hover"] = "hover";
  CompBulkselectorColorBackground["pressed"] = "pressed";
  return CompBulkselectorColorBackground;
}({});
var CompBulkselectorColorBorder = exports.CompBulkselectorColorBorder = /*#__PURE__*/function (CompBulkselectorColorBorder) {
  CompBulkselectorColorBorder["focusring"] = "focusring";
  return CompBulkselectorColorBorder;
}({});
var CompBulkselectorColorText = exports.CompBulkselectorColorText = /*#__PURE__*/function (CompBulkselectorColorText) {
  CompBulkselectorColorText["default"] = "default";
  CompBulkselectorColorText["hover"] = "hover";
  CompBulkselectorColorText["pressed"] = "pressed";
  return CompBulkselectorColorText;
}({});
var CompBulkselectorColorIconfill = exports.CompBulkselectorColorIconfill = /*#__PURE__*/function (CompBulkselectorColorIconfill) {
  CompBulkselectorColorIconfill["default"] = "default";
  CompBulkselectorColorIconfill["hover"] = "hover";
  CompBulkselectorColorIconfill["pressed"] = "pressed";
  return CompBulkselectorColorIconfill;
}({});
var CompToastColorBackground = exports.CompToastColorBackground = /*#__PURE__*/function (CompToastColorBackground) {
  CompToastColorBackground["information"] = "information";
  CompToastColorBackground["success"] = "success";
  CompToastColorBackground["warning"] = "warning";
  CompToastColorBackground["error"] = "error";
  return CompToastColorBackground;
}({});
var CompToastColorText = exports.CompToastColorText = /*#__PURE__*/function (CompToastColorText) {
  CompToastColorText["link"] = "link";
  CompToastColorText["warning"] = "warning";
  CompToastColorText["information"] = "information";
  CompToastColorText["success"] = "success";
  CompToastColorText["error"] = "error";
  return CompToastColorText;
}({});
var CompToastColorBorder = exports.CompToastColorBorder = /*#__PURE__*/function (CompToastColorBorder) {
  CompToastColorBorder["warning"] = "warning";
  CompToastColorBorder["error"] = "error";
  CompToastColorBorder["success"] = "success";
  CompToastColorBorder["information"] = "information";
  return CompToastColorBorder;
}({});
var CompToastColorSemanticicon = exports.CompToastColorSemanticicon = /*#__PURE__*/function (CompToastColorSemanticicon) {
  CompToastColorSemanticicon["warning"] = "warning";
  CompToastColorSemanticicon["information"] = "information";
  CompToastColorSemanticicon["success"] = "success";
  CompToastColorSemanticicon["error"] = "error";
  return CompToastColorSemanticicon;
}({});
var CompToastColorCloseicon = exports.CompToastColorCloseicon = /*#__PURE__*/function (CompToastColorCloseicon) {
  CompToastColorCloseicon["warning"] = "warning";
  CompToastColorCloseicon["information"] = "information";
  CompToastColorCloseicon["success"] = "success";
  CompToastColorCloseicon["error"] = "error";
  return CompToastColorCloseicon;
}({});
var CompToastColorSeparator = exports.CompToastColorSeparator = /*#__PURE__*/function (CompToastColorSeparator) {
  CompToastColorSeparator["warning"] = "warning";
  CompToastColorSeparator["information"] = "information";
  CompToastColorSeparator["success"] = "success";
  CompToastColorSeparator["error"] = "error";
  return CompToastColorSeparator;
}({});
var CompSegmentedcontrolColorBackground = exports.CompSegmentedcontrolColorBackground = /*#__PURE__*/function (CompSegmentedcontrolColorBackground) {
  CompSegmentedcontrolColorBackground["default"] = "default";
  CompSegmentedcontrolColorBackground["hover"] = "hover";
  return CompSegmentedcontrolColorBackground;
}({});
var CompCalendarColorBackgroundCalendarevent = exports.CompCalendarColorBackgroundCalendarevent = /*#__PURE__*/function (CompCalendarColorBackgroundCalendarevent) {
  CompCalendarColorBackgroundCalendarevent["default"] = "default";
  CompCalendarColorBackgroundCalendarevent["hover"] = "hover";
  return CompCalendarColorBackgroundCalendarevent;
}({});
var CompCalendarColorBackgroundCellFilled = exports.CompCalendarColorBackgroundCellFilled = /*#__PURE__*/function (CompCalendarColorBackgroundCellFilled) {
  CompCalendarColorBackgroundCellFilled["default"] = "default";
  CompCalendarColorBackgroundCellFilled["hover"] = "hover";
  return CompCalendarColorBackgroundCellFilled;
}({});
var CompCalendarColorBackgroundCellNotfilled = exports.CompCalendarColorBackgroundCellNotfilled = /*#__PURE__*/function (CompCalendarColorBackgroundCellNotfilled) {
  CompCalendarColorBackgroundCellNotfilled["default"] = "default";
  CompCalendarColorBackgroundCellNotfilled["hover"] = "hover";
  return CompCalendarColorBackgroundCellNotfilled;
}({});
var CompCalendarColorIconIconfill = exports.CompCalendarColorIconIconfill = /*#__PURE__*/function (CompCalendarColorIconIconfill) {
  CompCalendarColorIconIconfill["disabled"] = "disabled";
  return CompCalendarColorIconIconfill;
}({});
var CompPlaceholderBackground = exports.CompPlaceholderBackground = /*#__PURE__*/function (CompPlaceholderBackground) {
  CompPlaceholderBackground["default"] = "default";
  return CompPlaceholderBackground;
}({});
var CompPlaceholderShimmer = exports.CompPlaceholderShimmer = /*#__PURE__*/function (CompPlaceholderShimmer) {
  CompPlaceholderShimmer["default"] = "default";
  return CompPlaceholderShimmer;
}({});
var CompTextlinkColorText = exports.CompTextlinkColorText = /*#__PURE__*/function (CompTextlinkColorText) {
  CompTextlinkColorText["default"] = "default";
  CompTextlinkColorText["pressed"] = "pressed";
  CompTextlinkColorText["hover"] = "hover";
  return CompTextlinkColorText;
}({});
var CompTextlinkColorBackground = exports.CompTextlinkColorBackground = /*#__PURE__*/function (CompTextlinkColorBackground) {
  CompTextlinkColorBackground["hover"] = "hover";
  CompTextlinkColorBackground["pressed"] = "pressed";
  return CompTextlinkColorBackground;
}({});
var CompAlertsColorBackground = exports.CompAlertsColorBackground = /*#__PURE__*/function (CompAlertsColorBackground) {
  CompAlertsColorBackground["information"] = "information";
  CompAlertsColorBackground["success"] = "success";
  CompAlertsColorBackground["warning"] = "warning";
  CompAlertsColorBackground["error"] = "error";
  return CompAlertsColorBackground;
}({});
var CompAlertsColorText = exports.CompAlertsColorText = /*#__PURE__*/function (CompAlertsColorText) {
  CompAlertsColorText["link"] = "link";
  CompAlertsColorText["warning"] = "warning";
  CompAlertsColorText["information"] = "information";
  CompAlertsColorText["success"] = "success";
  CompAlertsColorText["error"] = "error";
  return CompAlertsColorText;
}({});
var CompAlertsColorBorder = exports.CompAlertsColorBorder = /*#__PURE__*/function (CompAlertsColorBorder) {
  CompAlertsColorBorder["warning"] = "warning";
  CompAlertsColorBorder["information"] = "information";
  CompAlertsColorBorder["success"] = "success";
  CompAlertsColorBorder["error"] = "error";
  return CompAlertsColorBorder;
}({});
var CompAlertsColorSemanticicon = exports.CompAlertsColorSemanticicon = /*#__PURE__*/function (CompAlertsColorSemanticicon) {
  CompAlertsColorSemanticicon["warning"] = "warning";
  CompAlertsColorSemanticicon["information"] = "information";
  CompAlertsColorSemanticicon["success"] = "success";
  CompAlertsColorSemanticicon["error"] = "error";
  return CompAlertsColorSemanticicon;
}({});
var CompAlertsColorCloseicon = exports.CompAlertsColorCloseicon = /*#__PURE__*/function (CompAlertsColorCloseicon) {
  CompAlertsColorCloseicon["warning"] = "warning";
  CompAlertsColorCloseicon["information"] = "information";
  CompAlertsColorCloseicon["success"] = "success";
  CompAlertsColorCloseicon["error"] = "error";
  return CompAlertsColorCloseicon;
}({});
var CompAlertsColorSeparator = exports.CompAlertsColorSeparator = /*#__PURE__*/function (CompAlertsColorSeparator) {
  CompAlertsColorSeparator["warning"] = "warning";
  CompAlertsColorSeparator["information"] = "information";
  CompAlertsColorSeparator["success"] = "success";
  CompAlertsColorSeparator["error"] = "error";
  return CompAlertsColorSeparator;
}({});
var CompAlertsColorBar = exports.CompAlertsColorBar = /*#__PURE__*/function (CompAlertsColorBar) {
  CompAlertsColorBar["warning"] = "warning";
  CompAlertsColorBar["information"] = "information";
  CompAlertsColorBar["success"] = "success";
  CompAlertsColorBar["error"] = "error";
  return CompAlertsColorBar;
}({});
var CompShortcutBackground = exports.CompShortcutBackground = /*#__PURE__*/function (CompShortcutBackground) {
  CompShortcutBackground["default"] = "default";
  return CompShortcutBackground;
}({});
var RefColor = exports.RefColor = /*#__PURE__*/function (RefColor) {
  RefColor["neutral"] = "neutral";
  RefColor["coolneutral"] = "coolneutral";
  RefColor["blue"] = "blue";
  RefColor["mauve"] = "mauve";
  RefColor["purple"] = "purple";
  RefColor["pink"] = "pink";
  RefColor["red"] = "red";
  RefColor["green"] = "green";
  RefColor["yellow"] = "yellow";
  RefColor["orange"] = "orange";
  RefColor["teal"] = "teal";
  RefColor["coral"] = "coral";
  RefColor["raspberry"] = "raspberry";
  RefColor["null"] = "null";
  return RefColor;
}({});